import { IonInput, IonText } from '@ionic/react';
import { useField } from 'formik';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useDateFormatter } from '../../util/hooks';
import { IonItem } from '../ionic/IonItem';
import { FieldLocked } from '../ui/field-locked';
import { IonFormFieldProps } from './ion-form.field';

const IonFormDateField = (props: IonFormFieldProps): ReactElement => {
  const { label, inputProps, ...otherProps } = props;
  const { i18n } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [field, meta, _helper] = useField(otherProps as any);

  const date = useDateFormatter(field.value);

  const errorText = <IonText color="danger">{meta.error}</IonText>;

  let labelColor: string | undefined = 'primary';
  if (
    inputProps?.labelPlacement !== undefined &&
    inputProps?.labelPlacement !== 'floating'
  ) {
    labelColor = undefined;
  }

  return (
    <IonItem lines={'full'} className={props.className}>
      <IonInput
        {...field}
        value={date ?? i18n.t('common:last_activity_never')}
        labelPlacement={'floating'}
        {...inputProps}
      >
        <div slot="label">
          <IonText color={labelColor}>
            {label}{' '}
            <FieldLocked
              show={inputProps?.readonly || inputProps?.disabled ? true : false}
            />{' '}
            {errorText}
          </IonText>
        </div>
      </IonInput>
    </IonItem>
  );
};

export { IonFormDateField };
